import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {redirectIfUnavailableFabric} from "@/lib/handlers/utils.tsx";
import {ScheduledReportsList} from "@/pages/reports/schedule/ScheduledReportsList.tsx";
import {ScheduleReportActions} from "@/pages/reports/schedule/ScheduleReportActions.tsx";

export const ScheduledReports = () => {
  const {user} = useCurrentUserContext();
  return (
    <ContentContainer title="Scheduled Reports" actionsBar={user?.has_write_access && <ScheduleReportActions />}>
      <Helmet>
        <title>Scheduled Reports</title>
      </Helmet>
      <UpErrorBoundary onError={redirectIfUnavailableFabric("reports")}>
        <Suspense>
          <ScheduledReportsList />
        </Suspense>
      </UpErrorBoundary>
    </ContentContainer>
  );
};
